require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./service-devops-quality-assurance-devops.json") })
        }
      }, "path---service-devops-quality-assurance-devops");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---service-devops-quality-assurance-devops!./.cache/json/service-devops-quality-assurance-devops.json
// module id = 907
// module chunks = 231608221292675